










































































import { Component, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import CreateReportingPeriodRequest from '@/models/ReportingPeriods/CreateReportingPeriodRequest';

@Component({ name: 'ReportingPeriodCreate' })
export default class extends GiganautVueDialog {
	entity = new CreateReportingPeriodRequest();
	valid = false;
	showStartDatePicker = false;
	showEndDatePicker = false;

	@Watch('dialog')
	onDialogChanged(val: boolean) {
		if (val) {
			this.entity = new CreateReportingPeriodRequest();
			this.entity.fiscalYear = new Date().getFullYear();
		}
	}

	async save() {
		if (!(this.$refs.form as any).validate()) return;
		await AgencySettingsModule.createReportingPeriod(this.entity);
		this.dialog = false;
		this.$emit('created');
	}
}
